import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/pages/home.vue';
import DetailedList from '@/pages/detailedList.vue';
import ThirdPartInfoList from '@/pages/thirdPartInfoList.vue';
import ApplicationPermission from '@/pages/applicationPermission.vue';
import ShareList from '@/pages/shareList.vue';
Vue.use(Router);
export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
        name: 'home',
        path: '/home',
        component: Home
    },
    {
      name: 'detailedList',
      path: '/detailedList',
      component: DetailedList
    },
    {
      name: 'applicationPermission',
      path: '/applicationPermission',
      component: ApplicationPermission
    },
    {
      name: 'shareList',
      path: '/shareList',
      component: ShareList
    },
    {
      name: 'thirdPartInfoList',
      path: '/thirdPartInfoList',
      component: ThirdPartInfoList
    },
    { path: '*', redirect: '/' }
  ],
});